import Immutable from 'immutable';

import { createModuleState } from 'ps-gui';
import { createSearchModel } from './utils';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('SessionLog');

export default class SessionLogModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setInitialized() {
		return new SessionLogModel(this.#data.set('initialized', true));
	}

	initialize() {
		let model = createSearchModel('/api/dq/sv_portal_session');
		return this.setSearch(model).#setInitialized();
	}

	setSearch(model) {
		return new SessionLogModel(this.#data.set('search', model.getState()));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

